import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import PoItemsFilters from "./poItemsFilters";
import POItemsBody from "./poItemsBody";
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Job Cost PO ViewPoint Report
 * @returns {JSX.Element}
 * @constructor
 */
const PoItems = () => {
    const [poItemsData, setPOItemsData] = useState([]);
    const [reportFilters, setReportFilters] = useState({
        isLoading: false,
        isSubmitted: false,
    });

    const POFilterProps = {
        setReportFilters,
        setPOItemsData,
    }

    const POItemsBodyProps = {
        poItemsData,
        setPOItemsData,
        reportFilters
    }

    return (
        <>
            <Breadcrumb title="PO Items" parent="Invoicing"/>
            <PoItemsFilters {...POFilterProps}/>
            <LoadingIndicator isLoading={reportFilters.isLoading}/>
            <POItemsBody {...POItemsBodyProps}/>
        </>
    );
}

export default PoItems;
